module.exports = __webpack_public_path__ + "img/infinite_ethan.e08daad9.gif";